export default __webpack_public_path__ + "static/summer-b392cca4f7f1ff8d107446e5e040693a.jpg";